var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeagleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 234,
    viewBox: "0 0 231 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.585 121.742C230.585 136.036 227.77 150.189 222.3 163.395C216.83 176.6 208.813 188.599 198.706 198.706C188.599 208.813 176.6 216.83 163.395 222.3C150.189 227.77 136.036 230.585 121.742 230.585V121.742H230.585Z",
    fill: "#13BAB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.843C-1.24957e-06 94.5491 2.81529 80.3957 8.28514 67.1903C13.755 53.9849 21.7723 41.9862 31.8792 31.8792C41.9862 21.7723 53.9849 13.755 67.1903 8.28514C80.3957 2.81529 94.5491 6.24784e-07 108.843 0V108.843H0Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.585 121.742C230.585 107.449 227.77 93.2955 222.3 80.0902C216.83 66.8848 208.813 54.8861 198.706 44.7791C188.599 34.6721 176.6 26.6549 163.395 21.185C150.189 15.7152 136.036 12.8999 121.742 12.8999V121.742H230.585Z",
    fill: "#12C6C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.742 121.742V230.585C107.449 230.585 93.2957 227.77 80.0904 222.3C74.6163 220.032 74.9909 220.058 69.9804 216.948L8.93286 233.064L26.0949 178.021C12.9 157.442 12.9 136.036 12.9 121.742H121.742Z",
    fill: "#00A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeagleLogo);
export default __webpack_public_path__ + "static/media/beagle-logo.4f9df36ebc81cd19ea27f23601598105.svg";
export { ForwardRef as ReactComponent };